import {ProtocolQuery} from '../service-model/protocol-query.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-communication/operations/shell-protocol-namespace.const';
import {BenchmarkPositionRequest} from './pha-benchmark.model';

export class StartPhaBenchmarkShell implements ProtocolQuery {
    constructor(public readonly requestId: string, public readonly months: number, public readonly maximum: number,
                public readonly cash: number, public readonly positions: BenchmarkPositionRequest[]) {}
    getOperationName(): string { return `${SHELL_PROTOCOL_OPERATIONS_NS}.StartPhaBenchmarkShell`; }
}
export class GetPhaBenchmarkJobShell implements ProtocolQuery {
    constructor(public readonly requestId: string) {}
    getOperationName(): string { return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetPhaBenchmarkJobShell`; }
}
export class CancelPhaBenchmarkShell implements ProtocolQuery {
    constructor(public readonly requestId: string) {}
    getOperationName(): string { return `${SHELL_PROTOCOL_OPERATIONS_NS}.CancelPhaBenchmarkShell`; }
}
